import { useEffect, useRef, useContext } from 'react'
import { css } from '@emotion/react'
import useProductList from '@src/hooks/product/list/useProductList'
import ProductListItem from '../ProductListItem'
import Input from '@src/components/inputs/Input'
import LoadingIcon from '@src/components/icon/LoadingIcon'
import useDeleteVendorProductQuery from '@src/hooks/queries/product/useDeleteVendorProductQuery'
import { CenterModalContext } from '@src/contexts/popup/modal/CenterModalProvider'

type PropsType = {
	loadNext: boolean
	setLoadNext: React.Dispatch<React.SetStateAction<boolean>>
}

const ProductList = ({ loadNext, setLoadNext }: PropsType) => {
	const { openCenterModal, closeCenterModal } = useContext(CenterModalContext)
	const isLoading = useRef(false)
	const { getProjectListProps, getSearchBarProps } = useProductList({ limit: 10 })
	const { products, fetchNextPage, isFetching, removeProduct } = getProjectListProps()
	const { mutate } = useDeleteVendorProductQuery()
	useEffect(() => {
		if (!isFetching && loadNext && !isLoading.current) {
			isLoading.current = true
			fetchNextPage()
				.then(() => {
					isLoading.current = false
					setLoadNext(false)
				})
				.catch(() => {})
		}
	}, [fetchNextPage, loadNext, setLoadNext, isFetching])
	return (
		<div css={wrapperStyle}>
			<Input placeholder="상품명" {...getSearchBarProps()} />
			{products &&
				products.map((product) => {
					return (
						<ProductListItem
							key={`product-item-${product.no}`}
							product={product}
							onDelete={() => {
								openCenterModal(
									{ desc: '상품을 삭제하시겠어요?' },
									() => () => {
										mutate(product.no, {
											onSuccess: (resData) => {
												if (resData.success !== 1) {
													openCenterModal(
														{ desc: '상품 삭제에 실패했어요. 다시 시도해주세요' },
														closeCenterModal,
													)
												} else {
													removeProduct(product.no)
												}
											},
											onError: () => {
												openCenterModal(
													{ desc: '상품 삭제에 실패했어요. 다시 시도해주세요' },
													closeCenterModal,
												)
											},
										})
										closeCenterModal()
									},
									() => () => {
										closeCenterModal()
									},
								)
							}}
						/>
					)
				})}
			{isFetching && (
				<div css={loadingWrapperStyle}>
					<LoadingIcon />
				</div>
			)}
		</div>
	)
}
const wrapperStyle = css`
	padding: 2rem 10rem 5rem;
`
const loadingWrapperStyle = css`
	padding: 3rem 0;
	text-align: center;
`
export default ProductList
